import { render, staticRenderFns } from "./LettersOfRecommendationList.vue?vue&type=template&id=b748ebe0&"
import script from "./LettersOfRecommendationList.vue?vue&type=script&lang=js&"
export * from "./LettersOfRecommendationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports